import {
   HealthcareFacilityLocation,
   HealthcareFacilityLocationQuery,
   HealthcareFacilityUnit,
   HealthcareFacilityUnitQuery,
   ServiceProvidingLocation,
   ServiceProvidingLocationForCurrentPracticeQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';
import { ServiceLocationType } from '@dreryk/egabinet-healthcare-provider-published-language-api';

import { useCqrsGet, UseCqrsQueryOptions, UseCqrsQueryResult } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';

import { HealthcareProviderLocationIdentifier } from './healthcareProviderLocation.types';
import { healthcareProviderLocationSelector } from './healthcareProviderLocation.utils';

type HealthcareProviderLocation<
   IDENTIFIER_TYPE extends ServiceLocationType
> = IDENTIFIER_TYPE extends 'SERVICE_PROVIDING_LOCATION'
   ? ServiceProvidingLocation
   : IDENTIFIER_TYPE extends 'HEALTHCARE_FACILITY_LOCATION'
   ? HealthcareFacilityLocation
   : IDENTIFIER_TYPE extends 'HEALTHCARE_FACILITY_UNIT'
   ? HealthcareFacilityUnit
   : never;

export const useGetHealthcareProviderLocationByIdentifierCqrsGet = (
   healthcareLocationIdentifier: HealthcareProviderLocationIdentifier,
   options?: UseCqrsQueryOptions<HealthcareProviderLocation<typeof healthcareLocationIdentifier['type']>>
): UseCqrsQueryResult<HealthcareProviderLocation<typeof healthcareLocationIdentifier['type']>> => {
   return useCqrsGet<HealthcareProviderLocation<typeof healthcareLocationIdentifier['type']>>(() => {
      const LocationQuery = healthcareProviderLocationSelector(healthcareLocationIdentifier)({
         selectServiceProvidingLocation: () => ServiceProvidingLocationForCurrentPracticeQuery,
         selectHealthcareFacilityLocation: () => HealthcareFacilityLocationQuery,
         selectHealthcareFacilityUnit: () => HealthcareFacilityUnitQuery,
      });
      const query = new LocationQuery();
      query.id = Slot.of(healthcareLocationIdentifier.id);
      return query;
   }, options);
};
